import { ExcelTemplate } from '../../interfaces';
import * as XLSX from 'xlsx-js-style';
import { GeneralLedgerTemplate } from './gl/gl.template';
import { TrialBalanceTemplate } from './tb/tb.template';
import { AssemblyTemplate } from './assembly/assembly.template';
import { CapitalAccountTemplate } from './capital-account/capital-account.template';
import { BalanceSheetTemplate } from 'src/app/services/balance-sheet/bsTemplate';
import { ProfitAndLossTemplate } from './profit-and-loss/profitAndLossTemplate';
import { FsExportExcelData } from 'src/app/domain/financial-statement/utils/common/utilityClasses';


export class FinancialStatementTemplate implements ExcelTemplate {

  export(dataForExport: FsExportExcelData): XLSX.WorkBook {
    const gl = dataForExport.fs.gl;
    const tb = dataForExport.fs.tb;
    const bsPageData = dataForExport.bsPageData;
    const plPageData = dataForExport.plPageData;
    const capitalAccountData = dataForExport.capitalAccountData;
    const glTemplate = new GeneralLedgerTemplate();
    const book = XLSX.utils.book_new();
    if (gl && tb) {
      const glSheet = glTemplate.getSheet(gl);
      const tbSheet = new TrialBalanceTemplate().getSheet(tb);
      const assemblySheet = new AssemblyTemplate().getSheet(dataForExport.fs);
      const manualEntriesSheet = gl?.filter((data) => data.isManualEntry).length ?
        glTemplate.getSheet(gl?.filter((data) => data.isManualEntry)) :
        null;

      this.addSheetToTheBook(glSheet, 'Gl', book);
      this.addSheetToTheBook(manualEntriesSheet, 'Manual entries', book);
      this.addSheetToTheBook(tbSheet, 'Accounts', book);
      this.addSheetToTheBook(assemblySheet, 'Assembly', book);

    }
    const bsSheet = new BalanceSheetTemplate().getSheet(bsPageData);
    this.addSheetToTheBook(bsSheet, 'Balance sheet', book);
    const plSheet = new ProfitAndLossTemplate().getSheet(plPageData);
    this.addSheetToTheBook(plSheet, 'Profit and loss', book);
    const capitalAccSheet = new CapitalAccountTemplate().getCapitalAccountSheet(capitalAccountData);
    this.addSheetToTheBook(capitalAccSheet, 'Capital account', book);
    return book;
  }

  addSheetToTheBook(sheet: XLSX.Sheet, sheetName: string, book: XLSX.WorkBook): void {
    if (!sheet) {
      return;
    }
    XLSX.utils.book_append_sheet(book, sheet, sheetName);
  }

}
